import Loadable from 'react-loadable';

import { LEFT_NAV_BAR_ITEMS } from '@rover/constants/src/search/navBar.constants';
import { SEO_LOCATION_REGEX } from '@rover/constants/src/search/seo.constants';
import { FooterTheme } from '@rover/kibble/styles';
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import retry from '@rover/rsdk/src/modules/Network/retry';
import Route from '@rover/types/src/Route';
import {
  CA_COUNTRY_URL_PREFIX,
  COUNTRY_URL_PREFIXES_REGEX_PATTERN,
} from '@rover/utilities/roverGeo.constants';

import Loading from '../client/Loading';

const DogTrainingCityServicePage = Loadable({
  loader: () =>
    retry(
      () =>
        import(
          /* webpackChunkName: "DogTrainingCityServicePage" */ '@rover/react-lib/src/pages/landing/SeoLocation/pages/DogTraining/DogTrainingCityServicePage'
        )
    ),
  loading: Loading,
});

const SeoLocationPage = Loadable({
  loader: () =>
    retry(
      () =>
        import(
          /* webpackChunkName: "SeoLocationPageContainer" */ '@rover/react-lib/src/pages/landing/SeoLocation/SeoLocationPageContainer'
        )
    ),
  loading: Loading,
});

const SEO_LOCATION_ROUTE = {
  component: SeoLocationPage,
  componentName: 'SeoLocationPage',
  pageCategory: 'seo-location',
  pageName: 'seo-city-landing',
  cacheTag: ['page-seo-location'],
  isReactQueryRoute: true,
  navBarIsFullWidth: false,
};

const DOG_TRAINING_CITY_SERVICE_ROUTE = {
  component: DogTrainingCityServicePage,
  componentName: 'DogTrainingCityServicePage',
  pageCategory: 'seo-dog-training-city-landing',
  pageName: 'seo-dog-training-city-landing',
  cacheTag: ['page-dog-training-city-landing'],
  isReactQueryRoute: true,
  navBarIsFullWidth: true,
};

const routes: Route[] = [
  {
    path: `/:seoLocationSlug(${CA_COUNTRY_URL_PREFIX}/${SEO_LOCATION_REGEX.DOG_TRAINING_CITY_SERVICE.source})/`,
    ...DOG_TRAINING_CITY_SERVICE_ROUTE,
  },
  {
    path: `/:seoLocationSlug(${SEO_LOCATION_REGEX.DOG_TRAINING_CITY_SERVICE.source})/`,
    ...DOG_TRAINING_CITY_SERVICE_ROUTE,
  },
  {
    path: `/:countryCode(${COUNTRY_URL_PREFIXES_REGEX_PATTERN})/:seoLocationSlug(${SEO_LOCATION_REGEX.CITY_AND_NEIGHBORHOOD_SERVICE.source})/`,
    ...SEO_LOCATION_ROUTE,
  },
  {
    path: `/:seoLocationSlug(${SEO_LOCATION_REGEX.CITY_AND_NEIGHBORHOOD_SERVICE.source})/`,
    ...SEO_LOCATION_ROUTE,
  },
].map((route) => ({
  ...route,
  exact: true,
  footerTheme: FooterTheme.LIGHT,
  enableEdgeCache: true,
  suppressLanguagePicker: true,
  suppressGlobalAnnouncements: true,
  suppressAppInstallBanner: true,
  concept: CONCEPTS.marketing.growth,
  leftNavBarItems: [
    LEFT_NAV_BAR_ITEMS.BECOME_A_SITTER_LINK,
    LEFT_NAV_BAR_ITEMS.REFER_LINK,
    LEFT_NAV_BAR_ITEMS.OUR_SERVICES_LINK,
  ],
  cacheTag: [...route.cacheTag, 'page-seo', 'page-all'],
}));

export default routes;
